import { render, staticRenderFns } from "./TicketItemComments.vue?vue&type=template&id=6e75575c&"
import script from "./TicketItemComments.vue?vue&type=script&lang=js&"
export * from "./TicketItemComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports